import { Form, Descriptions, Typography, Tag } from 'antd'
import { useEffect, useState } from 'react'
import UserService from '../../../@services/user'
import moment from 'moment'

const userStatusMap = {
  0: { label: '锁定', value: 0, colorType: 'danger' },
  1: { label: '正常', value: 1, colorType: 'success' },
  2: { label: '删除', value: 2, colorType: 'secondary' },
}

export default function FormPage(props) {
  const { originForm } = props
  const [form] = Form.useForm(originForm)
  const user = props.originForm.getFieldsValue()
  const [roleSelectProps, setRoleSelectProps] = useState({
    options: [],
    mode: 'multiple',
    loading: false,
  })

  const [storeSelectProps, setStoreSelectProps] = useState({
    options: [],
    mode: 'multiple',
    loading: false,
  })

  useEffect(() => {
    const getStore = async () => {
      try {
        setStoreSelectProps(state => ({ ...state, loading: true }))
        const res = (await UserService.getStore()) || []
        const options = []
        const storeAllCodes = []
        res.forEach(item => {
          options.push({
            label: item.storeName,
            value: item.storeCode,
          })
          storeAllCodes.push(item.storeCode)
        })
        setStoreSelectProps(state => ({
          ...state,
          options,
        }))
      } catch (error) {
        console.log({ error })
      } finally {
        setStoreSelectProps(state => ({ ...state, loading: false }))
      }
    }

    const getRoleList = async () => {
      try {
        setRoleSelectProps(state => ({ ...state, loading: true }))
        const res = (await UserService.getAllRoleList()) || []
        setRoleSelectProps(state => ({
          ...state,
          options: (res || []).map(item => ({
            label: item.name,
            value: item.id,
          })),
        }))
      } catch (error) {
        console.log({ error })
      } finally {
        setRoleSelectProps(state => ({ ...state, loading: false }))
      }
    }

    getRoleList()
    getStore()
  }, [form, props])

  const renderStatus = status => {
    if (!status) {
      return ''
    }
    const userStatus = userStatusMap[user.status]
    return (
      <Typography.Text type={userStatus.colorType}>
        {userStatus.label}
      </Typography.Text>
    )
  }

  const renderRoles = roles => {
    const roleIds = roles || []
    return roleSelectProps.options.reduce((pre, item) => {
      if (roleIds.includes(item.value)) {
        pre.push(
          <Tag color={'success'} key={item.value}>
            {item.label}
          </Tag>
        )
      }
      return pre
    }, [])
  }

  const renderStores = codes => {
    const storeCodes = codes || []
    return storeSelectProps.options.reduce((pre, item) => {
      if (storeCodes.includes(item.value)) {
        pre.push(<Tag key={item.value}>{item.label}</Tag>)
      }
      return pre
    }, [])
  }

  return (
    <Form form={form} labelCol={{ span: 4 }} wrapperCol={{ span: 18 }}>
      <Form.Item name={'id'} style={{ display: 'none' }}>
        <></>
      </Form.Item>
      <Form.Item name={'status'} style={{ display: 'none' }}>
        <></>
      </Form.Item>
      <Form.Item name={'type'} style={{ display: 'none' }}>
        <></>
      </Form.Item>
      <Form.Item name={'name'} style={{ display: 'none' }}>
        <></>
      </Form.Item>
      <Form.Item name={'username'} style={{ display: 'none' }}>
        <></>
      </Form.Item>
      <Form.Item name={'password'} style={{ display: 'none' }}>
        <></>
      </Form.Item>
      <Form.Item name={'roles'} style={{ display: 'none' }}>
        <></>
      </Form.Item>
      <Form.Item name={'stores'} style={{ display: 'none' }}>
        <></>
      </Form.Item>
      <Form.Item name={'createdAt'} style={{ display: 'none' }}>
        <></>
      </Form.Item>
      <Form.Item name={'remark'} style={{ display: 'none' }}>
        <></>
      </Form.Item>

      <Descriptions
        bordered
        column={2}
        size={'small'}
        labelStyle={{ width: '90px' }}
      >
        <Descriptions.Item label="账号" span={2}>
          <span style={{ paddingRight: '5px' }} key="username">
            {user.username}
          </span>
          {user.type === 1 && (
            <Tag color="error" key="admin">
              超级管理员
            </Tag>
          )}
        </Descriptions.Item>
        <Descriptions.Item label="姓名">{user.name}</Descriptions.Item>
        <Descriptions.Item label="状态">
          {renderStatus(user.status)}
        </Descriptions.Item>
        <Descriptions.Item label="创建时间">
          {user.createdAt
            ? moment(user.createdAt).format('YYYY-MM-DD hh:mm:ss')
            : ''}
        </Descriptions.Item>
        <Descriptions.Item label="初始密码">{user.password}</Descriptions.Item>
        <Descriptions.Item label="关联角色" span={2}>
          {renderRoles(user.roles)}
        </Descriptions.Item>
        <Descriptions.Item label="数据权限" span={2}>
          {renderStores(user.stores)}
        </Descriptions.Item>

        <Descriptions.Item label="备注">{user.remark}</Descriptions.Item>
      </Descriptions>
    </Form>
  )
}
